module.exports = __webpack_public_path__ + "9cd2d21bfa7a48559482d5d5430a3cc7.jpg";